import React, { useEffect, useRef, useState } from "react";
import { processSteps } from "../data/mockData";

const Process = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-28 bg-white text-brand-charcoal border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-brand-mint-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">
            Our Process
          </p>
          <h2 className="font-heading text-3xl lg:text-4xl mb-4 text-gray-900">
            Our Simple 4-Step Process
          </h2>
          <p className="text-gray-500 text-[15px] max-w-xl mx-auto">
            From first contact to final finish, we make it easy
          </p>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {processSteps.map((step, index) => (
            <div
              key={step.step}
              className={`relative text-center transition-all duration-350 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              {/* Step Number */}
              <div className="relative inline-flex items-center justify-center mb-8">
                <div className="w-16 h-16 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center">
                  <span className="text-2xl font-heading text-brand-gold-dark">
                    0{step.step}
                  </span>
                </div>
              </div>

              {/* Connector Line */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-px bg-gradient-to-r from-brand-gold/40 to-transparent" />
              )}

              <h3 className="text-lg font-bold mb-3 text-gray-900">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-[220px] mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
